<template>
  <div>
    <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
      <v-breadcrumbs-item
        v-for="item in navSettingsOptions"
        :key="item.index"
        @click='() => {
          if (item.to) $router.push(item.to)
        }'
        :class='[
          item.to ? "cursor-pointer" : "cursor-default"
        ]'
      >
        <span class="text-breadcum-settings">
          {{ item.text }}
          <v-icon>mdi-chevron-right</v-icon>
        </span>
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-row class='mt-4'>
      <v-col>
        <h6 class="font-weight-bold">Sync With Quickbooks</h6>
        <p class='mt-2' style='font-size: 1rem'>
          Integration with QuickBooks works in both ways. Follow the steps below to set up quickbook sync. <br />
          <b>Items / Folders:</b> Changes in QuickBooks Items are synced with Britecheck. Products,
          created or updated in Britecheck, are pushed to QuickBooks.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-stepper v-model="stepper" class='integration__sync__stepper'>
          <v-stepper-header class='integration__sync__stepper__header px-6'>
            <v-row>
              <v-col cols='3' class='flex align-center'>
                <button
                  v-if='isStepperAvailable'
                  @click='handleStepperPrev'
                >
                  <img
                    src='@/assets/icons/svg/previous.svg'
                    style='width: 25px; height: 25px; display: block'
                  >
                </button>
              </v-col>
              <v-col cols='5' class='flex align-center justify-center'>
                <span class='subtitle-1'>{{currentStepsTitle}}</span>
              </v-col>
              <v-col cols='4' class='flex justify-end'>
                <span class='subtitle-1'>Step {{stepper}} of {{haveSteps}}</span>
                <button
                  v-if='isStepperAvailable'
                  :disabled='!letNextStep'
                  @click='handleStepperNext'
                  class='ml-2'
                >
                  <img
                    src='@/assets/icons/svg/next.svg'
                    style='width: 25px; height: 25px; display: block'
                  >
                </button>
              </v-col>
            </v-row>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <step1
                :isSelect='step1.isSelect'
                :haveSelected='step1'
                @selectWarehouse='v => {
                  step1.id = v.id,
                  step1.warehouse = v.warehouse,
                  step1.haveAdded = v.haveAdded
                }'
                @addWarehouseClick='step1.isSelect = false'
                @cancelWarehouseClick='step1.isSelect = true'
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <step2qbo
                v-if='info.system === "qbo" && stepper === 2'
                :warehouse='step1'
                :systemInfo='step2.systemInfo'
                :loading='step2.loading'
                :loaded='step2.loaded'
                :isContinue='step2.isContinue'
                :confirmLink='step2.confirmLink'
                :tested='step2.tested'
                :extendedFields='step2.accounts'
                @changeSelect='changeSelect'
                @testConnection='testConnection'
                @presetData='presetData'
              />
            </v-stepper-content>
            <v-stepper-content step='3'>
              <step3
                v-if='stepper === 3'
                :warehouse='step1'
                :systemInfo='step2.systemInfo'
                :inSync='step3.inSync'
                @doSync='doSync'
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row v-if='isStepperAvailable'>
      <v-col class='flex justify-center'>
        <v-btn
          color='#7972c0'
          depressed
          @click='handleStepperPrev'
        >
          <img
            src='@/assets/icons/svg/previous.svg'
            style='width: 16px; height: 16px; display: block; filter: invert(1)'
          >
          <span class='text-white ml-2'>
            Back
          </span>
        </v-btn>
        <v-btn
          :disabled='!letNextStep'
          class='ml-2'
          color='#7972c0'
          depressed
          @click='handleStepperNext'
        >
          <span class='text-white'>
            Next
          </span>
          <img
            class='ml-2'
            src='@/assets/icons/svg/next.svg'
            style='width: 16px; height: 16px; display: block; filter: invert(1)'
          >
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import step1 from '@/components/integration/sync/step1'
import step2qbo from '@/components/integration/sync/step2/qbo'
import step3 from '@/components/integration/sync/step3'
import service from '@/services/integrations'
export default {
  name: 'IntegrationsSync',
  data: () => ({
    navSettingsOptions: [
      {
        index: 1,
        text: 'Integrations',
        to: {
          name: 'IntegrationSelect'
        }
      },
      {
        index: 2,
        text: 'Quickbooks'
      }
    ],
    visibleStepperAttrs: true,
    stepper: 1,
    haveSteps: 3,
    info: {
      system: '',
      syncMode: 'AUTO'
    },
    step1: {
      isSelect: true,
      id: null,
      warehouse: null,
      haveAdded: false
    },
    step2: {
      clientId: '',
      clientSecret: '',
      syncMode: '',
      confirmLink: '',
      accounts: null,
      extendedFields: null,
      extendedFieldsIsValid: false,
      isContinue: false,
      loading: false,
      loaded: false,
      tested: false,
      systemInfo: {
        name: '',
        countCategories: 0,
        countItems: 0
      }
    },
    step3: {
      inSync: false
    },
    prevRoute: null
  }),
  computed: {
    ...mapGetters('integrations', {
      integrationInfo: 'getIntegrationInfo'
    }),
    isStepperAvailable() {
      if (this.stepper === 1 && !this.step1.isSelect) {
        return false
      }
      return this.stepper !== this.haveSteps
    },
    currentStepsTitle() {
      const step = this.stepper
      let result = ''
      switch (step) {
        case 1 :
          if (this.step1.isSelect) {
            result = 'Select or Create Warehouse'
          } else {
            result = 'Create new Warehouse'
          }
          break
        case 2 :
          result = 'Configuring Sync Options'
          break
        case 3 :
          result = 'Start Sync'
          break
      }
      return result
    },
    letNextStep() {
      if (this.stepper === 1 && this.step1.id) return true
      if (this.stepper === 2) {
        if (this.step2.isContinue) {
          return this.step2.tested && this.step2.extendedFieldsIsValid
        }
        return false
      }
      if (this.stepper === 3 && this.step3.syncIsGone) {
        return true
      }
      return false
    }
  },
  methods: {
    showStepperAttrs() {
      this.visibleStepperAttrs = true
    },
    hideStepperAttrs() {
      this.visibleStepperAttrs = false
    },
    changeSelect({ name, id }) {
      if (!this.step2.extendedFields) this.step2.extendedFields = {}
      this.step2.extendedFields[name] = +id
      this.checkExtendedFields()
    },
    checkExtendedFields() {
      if (Object.values(this.step2.extendedFields).length === this.step2.accounts.length) {
        this.step2.extendedFieldsIsValid = true
      } else this.step2.extendedFieldsIsValid = false
    },
    handleStepperPrev() {
      if (this.prevRoute.name && this.prevRoute.name !== 'IntegrationSelect') {
        this.$router.push(this.prevRoute)
      } else {
        if (this.stepper !== 1) {
          this.stepper--
        } else {
          this.$router.push({ name: 'IntegrationSelect' })
        }
      }
    },
    handleStepperNext() {
      if (this.stepper !== this.haveSteps) {
        this.stepper++
      }
    },
    presetData(payload) {
      for (const [key, val] of Object.entries(payload)) {
        this.step2[key] = val
      }
      this.checkExtendedFields()
    },
    async testConnection(info) {
      this.step2.loading = true
      const payload = {
        system: this.info.system
      }
      if (!info) {
        payload.data = {
          inventoryId: this.step1.id,
          clientId: this.step2.clientId,
          clientSecret: this.step2.clientSecret,
          syncMode: this.step2.syncMode
        }
      } else {
        payload.data = info
      }
      const response = await service.testConnection(payload)
      if (response?.data?.error?.type === 200) {
        this.step2.tested = true
        this.step2.loading = false
        this.step2.loaded = true
        if (!this.$checkEqualityStrings(response.data.data.status, 'CONNECTION_SUCCESS')) {
          this.step2.confirmLink = response.data.data.info.link
        } else {
          this.step2.systemInfo = {
            name: response.data.data.info.name || '',
            countCategories: response.data.data.info.countCategories || 0,
            countItems: response.data.data.info.countItems || 0
          }
          this.step2.accounts = response.data.data.extendedFields
          this.step2.isContinue = true
        }
      } else {
        this.step2.loading = false
        this.step2.loaded = false
      }
    },
    async doSync(clearInventory) {
      this.step3.inSync = true
      const payload = {
        system: this.info.system,
        data: {
          inventoryId: this.step1.id,
          clearInventory: clearInventory,
          extendedFields: this.step2.extendedFields
        }
      }

      const response = await service.synchronize(payload)
      if (!response) {
        this.step3.inSync = false
        return
      }
      if (response?.data?.error?.type === 200) {
        if (this.$checkEqualityStrings(response.data.data.status, 'SUCCESS')) {
          const getAllSyncsResponse = await service.getAllSyncs()
          if (getAllSyncsResponse?.data?.error?.type === 200) {
            this.$router.push({ name: 'IntegrationSyncSuccess', params: { id: this.step1.id } })
          } else {
            this.$showError('Error to load all syncs', getAllSyncsResponse?.data?.error?.message || 'The error has occurred during execution of the operation.')
          }
        } else {
          const conflicts = response.data.data.conflicts.map(item => {
            item.source.type = 'source'
            item.target.type = 'target'
            return item
          })
          this.$store.commit('integrations/setSynchronizationConflicts', conflicts)
          this.$router.push({ name: 'IntegrationResolve', params: { id: response.data.data.inventoryId } })
        }
      } else {
        this.step3.inSync = false
        this.$showError('Error to synchronize', (response?.data?.error?.message || 'The Error was caught during QuickBooks synchronization.'))
      }
    }
  },
  components: {
    step1,
    step2qbo,
    step3
  },
  created() {
    if (this.$checkEqualityStrings(this.$route.name, 'IntegrationSyncContinue')) {
      this.step1.id = +this.$route.params.warehouse
      this.info.system = this.$route.params.system
      this.step2.isContinue = true
      this.stepper = 2
    } else {
      this.info.system = this.$route.params.id
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  }
}
</script>

<style scoped lang="scss">
  .integration__sync__stepper {
    border: 1px solid rgba(grey, 0.35);
    box-shadow: none;
    &__header {
      display: flex;
      align-items: center;
      height: 60px;
      background-color: #f5f5f5;
      box-shadow: none;
      border-bottom: 1px solid rgba(grey, 0.35);
    }
  }
</style>
